import _ from 'lodash';
import templateStr from 'text!./templates/service-request-statement-documents.html';

export default ['$filter', '$state', '$q', 'ModalService', 'servicerequest.ServiceRequestService', 'servicerequest.ServiceRequestDocumentService', '$window', 'httpSettings', '$translate', 'ViewModelService', ($filter, $state, $q, ModalService, ServiceRequestService, ServiceRequestDocumentService, $window, httpSettings, $translate, ViewModelService) => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            serviceRequestId: '=',
            statementDocuments: '=', // Array of documents that will be associated with the statement
            srDocuments: '=', // Existing documents on the service request
            tableConfig: '=',
            hideAttacheDocs: '=',
            hideUploadDocs: '=',
            hideAddFiles: '=',
            usesAt: '@',
            hidePrivDoc: '='
        },

        link: (scope) => {
            scope.documentNotFoundURL = `${$window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'))}/ServiceRequestDocumentError`;
            scope.claimCenterDownloadURI = `${httpSettings.serviceBaseURLs.cc}document/servicerequest/servicerequestDocument`;
            scope.currentlyAttachedDocuments = scope.statementDocuments;
            scope.attachableDocuments = _.difference(scope.srDocuments, scope.statementDocuments);
            scope.toBeAttached = []; // Used to hold documents that are waiting to be added when Done is pressed
            scope.lastUploadNewDocIndex = -1;
            scope.newDocumentsList = [];

            scope.$watch('statementDocuments', (now, prev) => {
                if (prev !== now) {
                    scope.attachableDocuments = _.difference(scope.srDocuments, scope.statementDocuments);
                    scope.currentlyAttachedDocuments = _.union(scope.statementDocuments, scope.toBeAttached);
                    if (scope.lastUploadNewDocIndex !== -1) {
                        scope.deleteNewDocument(scope.lastUploadNewDocIndex);
                        scope.lastUploadNewDocIndex = -1;
                    }

                }
            }, true);

            scope.$watch('toBeAttached', (now, prev) => {
                if (prev !== now) {
                    scope.currentlyAttachedDocuments = _.union(scope.statementDocuments, scope.toBeAttached);
                    scope.attachableDocuments = _.difference(scope.srDocuments, scope.currentlyAttachedDocuments);
                }
            }, true);
            scope.metadataTemplate = {
                docUID: '001',
                documentSection: null,
                documentType: null,
                securityType: 'unrestricted',
                status: 'draft',
                serviceRequestId: scope.serviceRequestId
            };

            scope.getMetaData = (newDocIdx) => {
                const docSection = scope.newDocumentsList[newDocIdx].documentSection.value;
                if (docSection !== undefined) {
                    scope.metadataTemplate.documentSection = docSection.code;
                    // the place where the document upload is being used, at 'Invoice' or 'Quote' level or some other place
                    if (scope.usesAt === 'invoice') {
                        scope.metadataTemplate.documentType = 'invoice_ey';
                    } else {
                        if (docSection.code === 'autopd_ey' || docSection.code === 'property_ey') {
                            if (scope.usesAt === 'quote') {
                                scope.metadataTemplate.documentType = 'appraisal_ey';
                            } else {
                                scope.metadataTemplate.documentType = 'correspondence_ey';
                            }
                        } else if (docSection.code === 'accidentbenefits_ey' || docSection.code === 'bicasualty_ey' ||
                            docSection.code === 'pdliability_ey' || docSection.code === 'subrogation') {
                            scope.metadataTemplate.documentType = 'correspondence_ey';
                        }
                    }
                } else {
                    scope.metadataTemplate.documentSection = null;
                    scope.metadataTemplate.documentType = null;
                }
                if (scope.newDocumentsList[newDocIdx].isPrivilegedDoc && scope.newDocumentsList[newDocIdx].isPrivilegedDoc.value === true) {
                    scope.metadataTemplate.securityType = 'sensitive';
                } else {
                    scope.metadataTemplate.securityType = 'unrestricted';
                }
                scope.lastUploadNewDocIndex = newDocIdx;
                scope.metadataTemplate.serviceRequestId = scope.serviceRequestId;
                return scope.metadataTemplate;
            }

            scope.attachDocument = (document) => {
                scope.toBeAttached.push(document);
            };

            scope.finishAttachingDocuments = () => { // Associate all documents in staging
                scope.statementDocuments = _.union(scope.statementDocuments, scope.toBeAttached);
                scope.toBeAttached = [];
                scope.tableConfig.attachingDocuments = false;
            };

            scope.cancelAttachingDocuments = () => {
                scope.toBeAttached = [];
                scope.tableConfig.attachingDocuments = false;
            };

            scope.removeDocument = (document) => {
                // check if associated document. If in attaching mode, we need to check if the doc is waiting to be attached
                const attachedDocument = _.find(scope.srDocuments, {
                    publicID: document.publicID
                });
                if (attachedDocument) {
                    if (scope.tableConfig.attachingDocuments) {
                        for (let i = 0; i < scope.toBeAttached.length; i++) { // Find the doc in the toBeAttached list and remove
                            if (attachedDocument.publicID === scope.toBeAttached[i].publicID) {
                                scope.toBeAttached.splice(i, 1);
                            }
                        }
                    } else {
                        for (let j = 0; j < scope.statementDocuments.length; j++) {
                            if (attachedDocument.publicID === scope.statementDocuments[j].publicID) {
                                scope.statementDocuments.splice(j, 1);
                                return;
                            }
                        }
                    }
                } else { // a newly uploaded document
                    const title =
                        'servicerequest.controllers.AddNewStatementDocument.Remove Document';
                    const msg = $translate('servicerequest.views.add-new-statement-document.Are you sure you want to remove', {
                        documentName: document.name
                    });
                    const yesLabel = $filter('translate')('servicerequest.controllers.AddNewStatementDocument.Yes');
                    const noLabel = $filter('translate')('servicerequest.controllers.AddNewStatementDocument.No');
                    ModalService.showWarning(title, msg, null, yesLabel, null, noLabel)
                        .result.then(() => {
                            $q.when(ServiceRequestDocumentService.removeDocument(scope.serviceRequestId, document.publicID), (deleted) => {
                                if (deleted === true) {
                                    for (let i = 0; i < scope.statementDocuments.length; i++) {
                                        if (document.publicID === scope.statementDocuments[i].publicID) {
                                            scope.statementDocuments.splice(i, 1);
                                        }
                                    }
                                } else {
                                    ModalService.showWarning(
                                        'servicerequest.controllers.AddNewStatementDocument.Document deletion may have failed',
                                        'servicerequest.controllers.AddNewStatementDocument.Something may have gone wrong'
                                    );
                                }
                            }, () => {
                                ModalService.showError(
                                    'servicerequest.controllers.AddNewStatementDocument.Document deletion failed',
                                    'servicerequest.controllers.AddNewStatementDocument.Sorry your document could not be deleted at this time'
                                );
                            });
                        });
                }
            };

            scope.addFiles = () => {
                if (scope.newDocumentsList === undefined) {
                    scope.newDocumentsList = [];
                }
                const docVM = ViewModelService.create({
                    isPrivilegedDoc: false
                }, 'cc', 'edge.capabilities.servicerequest.document.dto.ServiceRequestDocumentDTO');
                scope.newDocumentsList.push(docVM);

            }

            scope.deleteNewDocument = (indexToRemove) => {
                /*scope.newDocumentsList.value =
                    scope.newDocumentsList.value.filter((_element, index) => {
                        return index !== indexToRemove;
                    });*/
                scope.newDocumentsList.splice(indexToRemove, 1);
            };
        }

    };
}];
